import type {
  DashboardBreakdown,
  DashboardFunnel,
  DashboardPeriod,
  DashboardQueue,
  DashboardSummary,
  DashboardTimeseries,
  DashboardTop,
} from "@/types";

import { BaseApi } from "./base.api";

/** Davr va (kerak bo'lsa) ixtiyoriy oraliq. */
export interface DashboardRangeQuery {
  period: DashboardPeriod;
  from?: string;
  to?: string;
  /** `request` so'rov qatorini indeks imzosi bilan kutadi. */
  [key: string]: string | number | undefined;
}

/**
 * Boshqaruv paneli — oltita alohida so'rov.
 *
 * NEGA BITTA EMAS: bloklar bir xil tezlikda eskimaydi. "Navbat" har
 * daqiqada yangilanishi kerak, kesimlar esa kunda bir marta ham yetadi.
 * Bitta katta javobda ularning hammasi eng tez-tez yangilanadigan blok
 * tezligida qayta hisoblanardi, sahifa esa birinchi raqamni oxirgi
 * so'rov tugaguncha kutardi.
 */
class DashboardApi extends BaseApi {
  summary(query: DashboardRangeQuery) {
    return this.request<DashboardSummary>("/admin/dashboard/summary", { query });
  }

  timeseries(query: DashboardRangeQuery) {
    return this.request<DashboardTimeseries>("/admin/dashboard/timeseries", { query });
  }

  funnel(query: DashboardRangeQuery) {
    return this.request<DashboardFunnel>("/admin/dashboard/funnel", { query });
  }

  breakdown(query: DashboardRangeQuery) {
    return this.request<DashboardBreakdown>("/admin/dashboard/breakdown", { query });
  }

  /** Davr parametri yo'q: navbat bugungi holat haqida. */
  queue() {
    return this.request<DashboardQueue>("/admin/dashboard/queue");
  }

  top(query: DashboardRangeQuery & { limit?: number }) {
    return this.request<DashboardTop>("/admin/dashboard/top", { query });
  }
}

export const dashboardApi = new DashboardApi();
